import { FC, useContext, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select, { GroupBase, OptionsOrGroups, SingleValue } from "react-select";

import { PracFieldProps } from "../types";
import { getPracDetails } from "src/helpers/case";
import AddPracticeModal from "src/components/modals/addPractice";
// import { AuthContext } from "src/context/authContext";
import { isFieldRequired } from "src/helpers/addCase";
// import { AddCaseSchema } from "src/validation/addCase";
import { CaseContext } from "src/context/caseContext";



const PracticeField: FC<PracFieldProps> = ({ 
  mode, shouldReset, shouldBeAbleToSearch, isAPILoading, fieldName, control, getPracticeListing, shouldDisable,
  clearPracListing, setValue, pracListing, isCancellable, dontResetDoctorField, watch, trigger
}): JSX.Element => {
  const [isModalVisible, updateModalVisibility] = useState<boolean>(false)
  const [selectedPractice, updateSelectedPractice] = useState<{ value: number; label: string; }>()
  const [menuIsOpen, setMenuIsOpen] = useState(false)

  // const { userData } = useContext(AuthContext)
  const { caseSchema, formControls } = useContext(CaseContext)
  // const validationSchema = AddCaseSchema(userData?.ref_type || "")

  const is_anesthesiologist = Boolean(watch("doctor_attributes.is_anesthesiologist"));
  const iAm = watch("doctor_attributes.i_am");
  // setValue("doctor_attributes.is_anesthesiologist",is_anesthesiologist)
  
  const { inputLabel, inputPlaceholder, linkTitle, doctorField } = getPracDetails(fieldName, is_anesthesiologist)

  useEffect(() => {
    if (shouldReset) {
      setValue(fieldName, 0)
      updateSelectedPractice(undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode])

  useEffect(() => {
    if (selectedPractice && shouldBeAbleToSearch) {
      setTimeout(() => {
        if (clearPracListing) clearPracListing()
      }, 200);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPractice])

  useEffect(() => {
    if (!isModalVisible && selectedPractice)
      setValue(fieldName, selectedPractice.value)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalVisible])

  const getPracticeListingAndUpdatePractice = (selectedPrac: { value: number; label: string; }, shouldUpdate: boolean) => {
    updateSelectedPractice(selectedPrac)
    setValue(fieldName, selectedPrac.value)
    if (fieldName.includes("doctor_attributes.treating_practice_id"))
      setValue("practice_name", selectedPrac.label)

    setTimeout(() => trigger(fieldName), 100)
    getPracticeListing("", true, selectedPrac.value)
  }

  const calculatePracValue = (value?: number | null) => {
    if (!value || value === 0) return;

    if (pracListing && pracListing.data) {
      if (selectedPractice) return selectedPractice
      else {
        const data = pracListing.data.find((prac) => prac.id === value)
        if (data)
          return { value: data.id, label: `${data.name}${data.address ? ` - ${data.address.full_address}` : ""}` }
        else
          getPracticeListing("", true, value)
      }
    }
  }

  const onChangePractice = (val?: { value: number; label: string; }) => {
    if (val) {
      updateSelectedPractice(val)
      setMenuIsOpen(false)
      if (fieldName === "doctor_attributes.treating_practice_id") {
        if (pracListing && pracListing.data && pracListing.data.length > 0) {
          const selectedPrac = pracListing.data
            .find((prac) => prac.id === (val as { value: number; label: string; }).value)
          if (selectedPrac) {
            const { address } = selectedPrac
            setValue("shipments_attributes", [
              {
                practice_type: selectedPrac.practice_type || "",
                ship_to_city: address.city,
                ship_to_street: address.street,
                ship_to_state: address.state,
                ship_to_suite: address.suite ?? "",
                ship_to_zip: address.zip,
                practice_id: selectedPrac.id,
                ship_to: "other",
                phone: selectedPrac.phone_number ? selectedPrac.phone_number.toString() : "",
                fax: selectedPrac.fax_number ? selectedPrac.fax_number.toString() : "",
              }
            ])
          }
        }
      }
    }
    if (!dontResetDoctorField) {
      if (doctorField) setValue(doctorField, 0)
    }
    trigger(fieldName)
  }

  return (
    <>
      <div className="col-md-12 col-lg-10">
        <Controller
          name={fieldName}
          control={control}
          defaultValue={0}
          render={({ field, fieldState: { error } }) => (
            <div className="row mb-2">
              {inputLabel ? (
                <label htmlFor={fieldName} className="form-label col-lg-3 col-md-3 col-12 p-2">
                  {inputLabel} {caseSchema && isFieldRequired(caseSchema, fieldName, iAm) ? '*' : ''}
                </label>
              ) : null}

              <div className={inputLabel ? "col-lg-9 col-md-9 col-12" : "col-12"}>
                <Select
                  key={mode}
                  menuIsOpen={menuIsOpen}
                  onMenuOpen={() => setMenuIsOpen(true)}
                  onMenuClose={() => setMenuIsOpen(false)}
                  inputId={fieldName}
                  placeholder={inputPlaceholder}
                  isSearchable={true}
                  isDisabled={shouldDisable}
                  required={caseSchema ? isFieldRequired(caseSchema, fieldName, iAm) : true}
                  isClearable={isCancellable}
                  {...field}
                  value={(field.value && calculatePracValue(field.value as number)) as unknown as SingleValue<unknown>}
                  onChange={(val) => {
                    if (val) {
                      field.onChange((val as { value: number; label: string; }).value)
                      onChangePractice(val as { value: number; label: string; })
                    } else {
                      field.onChange(null)
                      updateSelectedPractice(undefined)
                      setMenuIsOpen(true)
                      getPracticeListing("_", true)
                      setValue("shipments_attributes", [])
                      if (doctorField && !dontResetDoctorField) {
                        if (formControls) formControls.resetField(doctorField)
                      }
                    }
                  }}
                  // isSearchable={true}
                  filterOption={null}
                  noOptionsMessage={() => isAPILoading ? "Loading..." : "Please enter 3 or more characters to search..."}
                  onInputChange={shouldBeAbleToSearch ? (search) => getPracticeListing(search) : () => {}}
                  options={
                    (
                      !isAPILoading ? (
                        pracListing && pracListing.data && pracListing.data.length > 0 ?
                          pracListing.data.map((prac) => ({ value: prac.id, label: `${prac.name}${prac.address ? ` - ${prac.address.full_address}` : ""}` }))
                        : []
                      ) : []
                    ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                  }
                />
                {error && error.message ? (
                  <div dangerouslySetInnerHTML={{__html: error.message}} className="text-danger text-small mt-2 "></div>
                ) : null}
              </div>
            </div>
          )}
        />
      </div>
      <div className="col-md-12 col-lg-2 text-end text-lg-start mb-2 mb-lg-0">
        <button 
          onClick={() => !shouldDisable ? updateModalVisibility(true) : null} type="button" 
          className="btn btn-primary" disabled={shouldDisable}
        >
          Add Facility
        </button>
      </div>

      {isModalVisible ? (
        <AddPracticeModal
          title={linkTitle} shouldBeAbleToSearch={shouldBeAbleToSearch}
          isModalVisible={isModalVisible} hideModal={() => updateModalVisibility(false)}
          updateSelectedPractice={getPracticeListingAndUpdatePractice}
          is_provider={fieldName.includes("treating_doctor_id") ? true : false}
        /> 
      ) : null}
    </>
  )
}

export default PracticeField
